var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _path, _circle2, _path2, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbTestA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 71,
    fill: "#EDF1FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 40,
    width: 75,
    height: 62,
    rx: 2,
    stroke: "#4C6FFF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 55,
    width: 50,
    height: 17,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 77,
    width: 14,
    height: 17,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 77,
    width: 14,
    height: 17,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 77,
    width: 14,
    height: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 42C34 40.8954 34.8954 40 36 40H107C108.105 40 109 40.8954 109 42V48H34V42Z",
    fill: "#FF9349",
    stroke: "#4C6FFF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 75.2346,
    r: 14,
    fill: "#EDF1FF",
    stroke: "#4C6FFF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4404 71.1211L67.6865 79.7563H65.1377L69.0854 69.0923H70.6968L70.4404 71.1211ZM72.7256 79.7563L69.9644 71.1211L69.6787 69.0923H71.312L75.2744 79.7563H72.7256ZM72.6084 75.7866V77.6323H67.0493V75.7866H72.6084Z",
    fill: "#4C6FFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 43,
    width: 2,
    height: 2,
    fill: "#4C6FFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 43,
    width: 2,
    height: 2,
    fill: "#4C6FFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 43,
    width: 2,
    height: 2,
    fill: "#4C6FFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 43,
    width: 26,
    height: 2,
    fill: "#4C6FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbTestA);
export default __webpack_public_path__ + "static/media/ab_test_a.6c5200b0d253d03a206ed60f4a4a1abb.svg";
export { ForwardRef as ReactComponent };